import { render, staticRenderFns } from "./TransferSend.vue?vue&type=template&id=b83acfd8&scoped=true"
import script from "./TransferSend.vue?vue&type=script&lang=js"
export * from "./TransferSend.vue?vue&type=script&lang=js"
import style0 from "./TransferSend.vue?vue&type=style&index=0&id=b83acfd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83acfd8",
  null
  
)

export default component.exports